"use client";

import { useState } from "react";
import { BsTrash3 } from "react-icons/bs";
import { IoEllipsisHorizontalSharp } from "react-icons/io5";

import color from "constants/color";

const DeleteTooltip = ({ onRemove }: { onRemove: () => void }) => {
  const [isShowTooltip, setIsShowTooltip] = useState(false);

  return (
    <div className="relative pl-2" onBlur={() => setIsShowTooltip(false)} tabIndex={-1}>
      <div className="relative right-0 top-0">
        <IoEllipsisHorizontalSharp
          onClick={() => setIsShowTooltip(!isShowTooltip)}
          className="cursor-pointer"
          color={color.text.gray}
        />
      </div>
      {isShowTooltip && (
        <div className="absolute -right-4 top-[20px] cursor-pointer">
          <div
            className="flex h-[34px] w-[77px] items-center justify-center gap-2 rounded bg-white text-primary shadow-card"
            onClick={onRemove}
          >
            <BsTrash3 className="text-gray" size={12} color={color.text.gray} />
            <span className="text-xs">削除</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteTooltip;
